export const REQUEST_ANIMAL = 'REQUEST_ANIMAL'
export const ERROR_ANIMAL = 'ERROR_ANIMAL'

export const FETCH_ANIMAL_SUCCESS = 'FETCH_ANIMAL_SUCCESS'
export const FETCH_ANIMAL_ERROR = 'FETCH_ANIMAL_ERROR'

export const ADD_ANIMAL_SUCCESS = 'ADD_ANIMAL_SUCCESS'
export const ADD_ANIMAL_ERROR = 'ADD_ANIMAL_ERROR'

export const DELETE_ANIMAL_SUCCESS = 'DELETE_ANIMAL_SUCCESS'
export const DELETE_ANIMAL_ERROR = 'DELETE_ANIMAL_ERROR'

export const EDIT_ANIMAL_SUCCESS = 'EDIT_ANIMAL_SUCCESS'
export const EDIT_ANIMAL_ERROR = 'EDIT_ANIMAL_ERROR'

export const EDIT_PICTURES_SUCCESS = 'EDIT_PICTURES_SUCCESS'
export const EDIT_PICTURES_ERROR = 'EDIT_PICTURES_ERROR'

export const FETCH_REQUEST_ANIMAL_LIST = 'FETCH_REQUEST_ANIMAL_LIST'
export const FETCH_SUCCESS_ANIMAL_LIST = 'FETCH_SUCCESS_ANIMAL_LIST'
export const FILTER_LIST_SUCCESS = 'FILTER_LIST_SUCCESS'
export const FETCH_ERROR_ANIMAL_LIST = 'FETCH_ERROR_ANIMAL_LIST'

export const FETCH_REQUEST_USERS_ANIMALS = 'FETCH_REQUEST_USERS_ANIMALS'
export const FETCH_SUCCESS_USERS_ANIMALS = 'FETCH_SUCCESS_USERS_ANIMALS'
export const FETCH_ERROR_USERS_ANIMALS = 'FETCH_ERROR_USERS_ANIMALS'

export const FETCH_REQUEST_LOGIN = 'FETCH_REQUEST_LOGIN'
export const FETCH_SUCCESS_LOGIN = 'FETCH_SUCCESS_LOGIN'
export const FETCH_ERROR_LOGIN = 'FETCH_ERROR_LOGIN'

export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS'
export const LOGOUT_ERROR = 'LOGOUT_ERROR'

export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS'
export const SIGNUP_ERROR = 'SIGNUP_ERROR'

export const RECOVER_SUCCESS = 'RECOVER_SUCCESS'
export const RECOVER_ERROR = 'RECOVER_ERROR'

export const REFRESH_USER_SUCCESS = 'REFRESH_USER_SUCCESS'
export const REFRESH_USER_ERROR = 'REFRESH_USER_ERROR'

export const REQUEST_USER = 'REQUEST_USER'
export const FETCH_SUCCESS_USER = 'FETCH_SUCCESS_USER'
export const FETCH_USER_ERROR = 'FETCH_USER_ERROR'

export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS'
export const DELETE_USER_ERROR = 'DELETE_USER_ERROR'

export const EDIT_USER_SUCCESS = 'EDIT_USER_SUCCESS'
export const EDIT_USER_ERROR = 'EDIT_USER_ERROR'

export const UPLOAD_PHOTO_USER_SUCCESS = 'UPLOAD_PHOTO_USER_SUCCESS'
export const UPLOAD_PHOTO_USER_ERROR = 'UPLOAD_PHOTO_USER_ERROR'

export const RESET = 'RESET'
export const RESET_ANIMAL = 'RESET_ANIMAL'
export const RESET_USER = 'RESET_USER'

export const REVIEW_REQUEST = 'REVIEW_REQUEST'
export const POST_REVIEW_SUCCESS = 'POST_REVIEW_SUCCESS'
export const POST_REVIEW_ERROR = 'POST_REVIEW_ERROR'
export const DELETE_REVIEW_SUCCESS = 'DELETE_REVIEW_SUCCESS'
export const DELETE_REVIEW_ERROR = 'DELETE_REVIEW_ERROR'
export const RESET_REVIEW = 'RESET_REVIEW'

export default {
    REQUEST_ANIMAL,
    ERROR_ANIMAL,
    FETCH_ANIMAL_SUCCESS,
    FETCH_USER_ERROR,
    FETCH_ERROR_USERS_ANIMALS,
    FETCH_ANIMAL_ERROR,
    FETCH_ERROR_ANIMAL_LIST,
    FETCH_REQUEST_LOGIN,
    FETCH_REQUEST_USERS_ANIMALS,
    FETCH_SUCCESS_ANIMAL_LIST,
    FETCH_SUCCESS_LOGIN,
    FETCH_SUCCESS_USER,
    REVIEW_REQUEST,
    RESET_REVIEW,
    REFRESH_USER_ERROR,
    REFRESH_USER_SUCCESS,
    RESET,
    RESET_ANIMAL,
    RESET_USER,
    POST_REVIEW_ERROR,
    POST_REVIEW_SUCCESS,
    ADD_ANIMAL_ERROR,
    ADD_ANIMAL_SUCCESS,
    DELETE_REVIEW_ERROR,
    DELETE_REVIEW_SUCCESS,
    DELETE_USER_ERROR,
    DELETE_USER_SUCCESS,
    DELETE_ANIMAL_ERROR,
    DELETE_ANIMAL_SUCCESS,
    EDIT_USER_SUCCESS,
    EDIT_USER_ERROR,
    EDIT_PICTURES_ERROR,
    EDIT_ANIMAL_ERROR,
    EDIT_ANIMAL_SUCCESS,
    EDIT_PICTURES_SUCCESS,
    UPLOAD_PHOTO_USER_ERROR,
    UPLOAD_PHOTO_USER_SUCCESS,
    LOGOUT_ERROR,
    LOGOUT_SUCCESS,
    SIGNUP_ERROR,
    SIGNUP_SUCCESS,
    RECOVER_ERROR,
    RECOVER_SUCCESS,

}
